var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddmsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1057",
    "data-name": "Rectangle 1057",
    width: 22,
    height: 22,
    transform: "translate(-2 -1.659)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395",
    transform: "translate(2 -2.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394",
    transform: "translate(0 4)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2828",
    "data-name": "Path 2828",
    d: "M9.1.006A9.123,9.123,0,0,1,18.129,7.3a8.874,8.874,0,0,1-2.2,8.041,8.832,8.832,0,0,1-5.5,2.909,9,9,0,0,1-5.56-.945.524.524,0,0,0-.418-.038c-.944.271-1.892.531-2.835.806a1.075,1.075,0,0,1-1.139-.261A1.073,1.073,0,0,1,.23,16.664q.416-1.414.845-2.824a.511.511,0,0,0-.034-.418A8.782,8.782,0,0,1,.016,9.771a8.994,8.994,0,0,1,3.1-7.492A8.9,8.9,0,0,1,7.779.1,6.358,6.358,0,0,1,9.1.006M16.97,9.1a5.355,5.355,0,0,0-.093-1.17A7.67,7.67,0,0,0,14.223,3.2,7.633,7.633,0,0,0,7.99,1.4a7.553,7.553,0,0,0-4.883,2.72A7.681,7.681,0,0,0,1.33,10.079,7.285,7.285,0,0,0,2.2,12.835a1.749,1.749,0,0,1,.137,1.44c-.231.735-.446,1.474-.668,2.212-.017.055-.067.12-.019.167s.113-.007.167-.023c.719-.213,1.445-.409,2.153-.655a1.877,1.877,0,0,1,1.568.148,7.665,7.665,0,0,0,4.948.757A7.844,7.844,0,0,0,16.97,9.1",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2829",
    "data-name": "Path 2829",
    d: "M159.008,107.729c0-.747,0-2.658,0-3.406a.738.738,0,0,1,.709-.82.75.75,0,0,1,.742.8c.009.856,0,2.876,0,3.732q0,.958,0,1.916a.807.807,0,0,1-.36.747.659.659,0,0,1-.72.026.684.684,0,0,1-.372-.622c0-.791,0-1.582,0-2.373",
    transform: "translate(-150.536 -97.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2830",
    "data-name": "Path 2830",
    d: "M107.088,159.943h-2.242a.738.738,0,0,1-.821-.709.75.75,0,0,1,.8-.742c.856-.009,1.712,0,2.569,0,.639,0,2.441,0,3.079,0a.807.807,0,0,1,.747.36.658.658,0,0,1,.026.72.684.684,0,0,1-.622.372c-.791,0-2.745,0-3.536,0",
    transform: "translate(-98.483 -150.042)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddmsg);
export default __webpack_public_path__ + "static/media/addmsg.e0d4877c8b92a095a957275ee4ebc175.svg";
export { ForwardRef as ReactComponent };